import { markRaw } from "vue";
import { isJingxiStation, isHaisidaStation } from "./stationTemplateMap.js";
import BaseStatement from "../statement_base.vue";
import RunXingTaiStatement from "../statement_runxingtai.vue";
import MeterStatement from "../MeterStatement.vue";

import baseImg from "@/assets/base.png";
import hengyunImg from "@/assets/heng_yun.png";
import jingxiImg from "@/assets/jingxi.png";
import haisidaImg from "@/assets/haisida.png";

/**
 * 抄表结算-模板元信息配置。
 *
 * 原 Statement.vue 用 formData~formData5 + 5 段 v-if + 硬编码 stationId 判断分散管理,
 * 现集中为一张配置表,页面据此驱动:主区渲染哪个组件、抽屉里展示哪些可选模板卡片、
 * 每个模板用哪种参数表单。
 *
 * 字段说明:
 * - id:模板 id,对应后端 templateId,也是 isType 的取值
 * - name:模板显示名(国际化 key,运行时经 $str 取值)
 * - img:预览图
 * - formType:抽屉内参数表单类型
 *     'single' 仅用户方(基础模板)
 *     'ratio'  用户方(甲)/投资方(乙)+ 分成比例 + 蓄电功率/储能差值(运行泰)
 *     'party'  仅用户方(甲)/投资方(乙),无分成(电表维度各模板)
 * - component:主区渲染组件
 * - props:传给组件的额外静态 props(如 MeterStatement 的 templateKey)
 * - visible(stationId):该模板是否对当前电站可选
 */
export const STATEMENT_TEMPLATES = [
  {
    id: 1,
    nameKey: "收益管理/基础模板",
    img: baseImg,
    formType: "single",
    component: markRaw(BaseStatement),
    props: {},
    visible: () => true
  },
  {
    id: 2,
    nameKey: "收益管理/以电站多种结算项维度结算",
    img: hengyunImg,
    formType: "ratio",
    component: markRaw(RunXingTaiStatement),
    props: {},
    visible: () => true
  },
  {
    id: 4,
    nameKey: "收益管理/以电表维度统计结算",
    img: jingxiImg,
    formType: "party",
    component: markRaw(MeterStatement),
    props: { templateKey: "common" },
    visible: stationId => !isJingxiStation(stationId)
  },
  {
    id: 3,
    nameKey: "收益管理/津西模板",
    img: jingxiImg,
    formType: "party",
    component: markRaw(MeterStatement),
    props: { templateKey: "jingxi" },
    visible: stationId => isJingxiStation(stationId)
  },
  {
    id: 5,
    nameKey: "收益管理/海四达模板",
    img: haisidaImg,
    formType: "party",
    component: markRaw(MeterStatement),
    props: { templateKey: "haisida" },
    visible: stationId => isHaisidaStation(stationId)
  }
];

/** 按 id 取模板配置 */
export function getTemplateById(id) {
  return STATEMENT_TEMPLATES.find(t => t.id === Number(id));
}

/** 当前电站可选的模板列表 */
export function getVisibleTemplates(stationId) {
  return STATEMENT_TEMPLATES.filter(t => t.visible(stationId));
}
